<div class="about" [dir]="language == 'ar' ? 'rtl' : 'ltr'">
  <h3>
    {{ "about_title1" | translate }}
    <span> {{ "about_title2" | translate }}</span>
  </h3>
  <p>
    {{ "about_title-content" | translate }}
  </p>

  <div *ngFor="let comp of aboutusComponents">
    <ng-container [ngSwitch]="comp.type">
      <div *ngSwitchCase="'app-text-with-one-image'">
        <app-text-with-one-image
          [data]="comp.details"
        ></app-text-with-one-image>
      </div>
    </ng-container>
  </div>
</div>
